<template>
  <div class="wrapper">
    <div class="page-header">
      <img id="insure_show" :src="require('@/assets/imgs/student/header.png')" />
      <div class="money-box">
        {{ dataForm.premium }}元
        <span>/{{dataForm.periodNumber>1?dataForm.periodNumber:''}}年</span>
      </div>
      <div class="icon-box">
        <img :src="insureImgUrl" />
      </div>
    </div>
    <div class="page-project">
      <div class="right">
        <div class="top">
          <img :src="require('@/assets/imgs/student/bz.png')" />保障项目
        </div>
        <div class="bottom">意外伤害、疾病身故等多重风险保障</div>
      </div>
    </div>
    <van-cell
      :border="false"
      v-for="(item,idx) in clauseJson"
      :key="idx"
      :title="item.name"
      :value="item.claims"
    />
    <van-divider :style="{ margin: '0px' }" />
    <div class="money-box">
      <van-cell
        :border="false"
        title="保费"
        :value="'¥'+dataForm.premium+'元/'+(dataForm.periodNumber>1?dataForm.periodNumber:'')+'年'"
      />
    </div>
    <div class="divider-box"></div>
    <div class="phone-view">
      <div class="title">投保咨询电话</div>
      <div class="phone-item">
        <div class="left">手机：</div>
        <div class="right">
          <label
            @click="handleCallClick(item)"
            v-for="(item,idx) in insurePhone"
            :key="idx"
          >{{item}}</label>
        </div>
      </div>
    </div>
    <div class="divider-box"></div>
    <div class="lp-view">
      <div class="title">
        <img :src="require('@/assets/imgs/student/lc.png')" />
        理赔步骤
      </div>
      <van-steps
        direction="vertical"
        active-color="#333436"
        inactive-color="#333436"
        active-icon="circle"
        inactive-icon="circle"
      >
        <van-step>
          <p>拨打理赔电话</p>
        </van-step>
        <van-step>
          <p>提供理赔资料</p>
        </van-step>
        <van-step>
          <p>审核保险责任，10个工作日确认理赔</p>
        </van-step>
        <van-step>
          <p>赔付资金支付至投保人账户</p>
        </van-step>
      </van-steps>
    </div>
    <div style="height:5rem"></div>
    <div class="button-save" v-show="!$ComTools.isEmptyString(categoryId)">
      <van-button @click="handleGoClick" type="primary" block color="#FFC281">立即投保</van-button>
    </div>
    <a :href="telPhone" v-show="false" ref="tels"></a>
  </div>
</template>

<script>
import { getJsapiTicket, findCategoryById } from "@/api/common";
export default {
  data() {
    return {
      insureImgUrl: require("@/assets/imgs/student/picc.png"),
      categoryId: "",
      belongerId: "",
      platformId: "",
      telPhone: "",
      insurePhone: [],
      dataForm: {},
      clauseJson: [],
    };
  },
  created() {
    document.title = "学生 幼儿意外伤害保险(学平险)";
    this.categoryId = this.$route.query.categoryId;
    this.belongerId = this.$route.query.belongerId || "";
    this.platformId = this.$route.query.platformId || "";
    this.findCategoryById(this.categoryId);
    // if (!this.$ComTools.isEmptyString(this.categoryId)) {
    //   this.insureImgUrl = require("@/assets/imgs/insure" +
    //     this.categoryId +
    //     ".png");
    // }
  },
  mounted() {
    let sUrl = location.href.split("#")[0];
    let sImgUrl = "http://nywx.e-ibdt.cn/file/logo/logo_picc.png";
    getJsapiTicket({ appid: process.env.WXKey, url: sUrl }).then((res) => {
      if (res.code === 0) {
        this.$ComTools.wxShare(
          res.data,
          sUrl,
          sImgUrl,
          "中国人保学平险互联网投保",
          "学生、幼儿意外伤害保险方案 意外伤害、疾病、多重风险保障"
        );
      }
    });
  },
  methods: {
    findCategoryById(id) {
      findCategoryById({ id: id }).then((res) => {
        if (res.code == 0) {
          let data = res.data;
          this.dataForm = data;
          if (data.urlLogo) this.insureImgUrl = '/api/file' + data.urlLogo
          this.clauseJson = this.$ComTools.isEmptyString(data.clauseJson)
            ? []
            : JSON.parse(data.clauseJson);
          if (!this.$ComTools.isEmptyString(data.insurePhone)) {
            this.insurePhone = data.insurePhone.split(",");
          }
        }
      });
    },
    handleGoClick() {
      this.$router.push({
        path: "/insure/studentform",
        query: {
          categoryId: this.categoryId,
          belongerId: this.belongerId,
          platformId: this.platformId,
        },
      });
    },
    handleCallClick(phone) {
      this.telPhone = "tel:" + phone;
      this.$nextTick(() => {
        this.$refs.tels.click();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  .page-header {
    width: 100%;
    position: relative;
    .money-box {
      position: absolute;
      bottom: 1.3rem;
      left: 1.2rem;
      background-color: #42a7ff;
      color: white;
      height: 4.5rem;
      width: 4.5rem;
      line-height: 4.5rem;
      text-align: center;
      border-radius: 50%;
      font-size: 1rem;
      font-weight: bold;
      span {
        font-size: 0.7rem;
      }
    }
    .icon-box {
      position: absolute;
      bottom: 0.4rem;
      right: 1.3rem;
      img {
        width: 7rem;
      }
    }
  }
  .page-project {
    width: 100%;
    display: flex;
    padding: 0.6rem 16px;
    .left {
    }
    .right {
      width: 100%;
      display: flex;
      flex-direction: column;
      .top {
        color: #303133;
        font-size: 1rem;
        font-weight: bold;
        display: flex;
        align-items: center;
        line-height: 21px;
        img {
          width: 1.2rem;
          height: 1.2rem;
          margin-right: 5px;
        }
      }
      .bottom {
        color: #666668;
        font-size: 0.7rem;
        padding-left: 1.6rem;
      }
    }
  }
  .money-box {
    /deep/ .van-cell__value {
      color: #333436;
      font-size: 1rem;
      font-weight: bold;
    }
  }
  .divider-box {
    width: 100%;
    height: 0.6rem;
    background-color: #f2f2f2;
  }
  .phone-view {
    width: 100%;
    padding: 1rem 16px;
    .title {
      color: #303133;
      font-size: 1rem;
      font-weight: bold;
    }
    .phone-item {
      width: 100%;
      display: flex;
      padding-top: 0.5rem;
      .left {
      }
      .right {
        display: flex;
        flex-direction: column;
      }
    }
  }
  .lp-view {
    width: 100%;
    padding: 1rem 16px;
    .title {
      width: 100%;
      display: flex;
      align-items: center;
      color: #303133;
      font-size: 1rem;
      font-weight: bold;
      line-height: 21px;
      img {
        width: 1.2rem;
        height: 1.2rem;
        margin-right: 5px;
      }
    }
    /deep/ .van-step__icon {
      background-color: white;
      color: #ff912d !important;
    }
    /deep/ .van-step__line {
      background: #ff912d !important;
    }
  }
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.button-save {
  /deep/ .van-button {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99999;
    // color: black !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/insurance/student.vue